import { render } from "./SubiektRouteSelectModal.vue?vue&type=template&id=a98872da&scoped=true"
import script from "./SubiektRouteSelectModal.vue?vue&type=script&lang=js"
export * from "./SubiektRouteSelectModal.vue?vue&type=script&lang=js"

import "./SubiektRouteSelectModal.vue?vue&type=style&index=0&id=a98872da&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a98872da"]])

export default __exports__